import { Grid, Paper, Stack, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import BarItemTooltip from "../../BarItemTooltip";
import { formatInteger } from "../../formatters";
import { StepBarSection } from "../usersApiMapping";

function CategoryBarChart({
  title,
  color,
  data,
}: {
  title: string;
  color: string;
  data: StepBarSection["allBars"];
}) {
  return (
    <Paper variant="outlined" sx={{ p: "18px 20px", borderColor: "#ececec" }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        {title}
      </Typography>
      <BarChart
        height={270}
        xAxis={[{ scaleType: "band", data: data.map((entry) => entry.label) }]}
        series={[
          {
            data: data.map((entry) => entry.value),
            color,
            valueFormatter: (value) => (value === null ? "" : formatInteger(value)),
          },
        ]}
        tooltip={{ trigger: "none" }}
      >
        <BarItemTooltip />
      </BarChart>
    </Paper>
  );
}

interface UsersStepBarSectionProps {
  section: StepBarSection;
}

export default function UsersStepBarSection({ section }: UsersStepBarSectionProps) {
  return (
    <Stack spacing={2.5}>
      <CategoryBarChart title={section.allTitle} color="#8E24AA" data={section.allBars} />
      <Grid container spacing={2.5}>
        <Grid item xs={12} md={6}>
          <CategoryBarChart title={section.leadTitle} color="#5B9BD5" data={section.leadBars} />
        </Grid>
        <Grid item xs={12} md={6}>
          <CategoryBarChart title={section.qualTitle} color="#2E7D32" data={section.qualBars} />
        </Grid>
      </Grid>
    </Stack>
  );
}
